export default "__VITE_ASSET__ByMBbI85__"